export default "__VITE_ASSET__BYFHAbwJ__"